class AsistenciaService {
  constructor() {}
  resources = () => ({
    asistencia: {
      uri: `/v1/unidadcomedor/rptasistenciacomedor`,
      method: ['get']
    }
  });
}

export default AsistenciaService;
